<template>

    <div class="pin-top">

        <!-- Top navbar -->
        <navbar-header
            :classList="['bg-danger', 'text-light']"
            :right="'close-mpl'">
        </navbar-header>

        <!-- Prompt Layout -->
        <prompt-div class="text-light">

            <!-- Layout body -->
            <template v-slot:body>
                <img alt="" src="/images/illustration-error.svg">
                <div class="pt-9">
                    <h2 class="font-xl font-weight-bold">Oops!<br/>Something went wrong</h2>
                    <h4 class="font-md mt-5">Sorry but your session has already expired.</h4>
                </div>
            </template>

        </prompt-div>

    </div>

</template>

<script>
    export default {
        beforeCreate: function() {
            document.body.className = 'bg-danger';
        },
    }
</script>
